export function isNetworkElementSupported(row, networkElement) {
  return networkElement === 'DU' || Boolean(row.su);
}

export function getRowGroups(rows, groupBy = 'group') {
  return Object.values(
    rows.reduce((acc, row) => {
      const group = row[groupBy];
      acc[group] = acc[group] ?? { id: group, rows: [] };
      acc[group].rows.push(row);

      return acc;
    }, {})
  );
}

export function getColumnGroups(columns, result = [], level = 0) {
  return columns.reduce((acc, column) => {
    acc[level] = acc[level] ?? { id: level, columns: [] };
    acc[level].columns.push(column);

    if (column.columns) {
      return getColumnGroups(column.columns, acc, level + 1);
    }

    return acc;
  }, result);
}

export function renderHeader(column) {
  if (typeof column.header === 'function') {
    return column.header();
  }

  return column.header ?? column.id;
}

export function renderCell(row, column) {
  if (typeof column.cell === 'function') {
    return column.cell(row, column);
  }

  return row[column.id] ?? '';
}
